import React from 'react'
import { TimelineLite, TweenMax } from 'gsap'

export default {

    initialise (SlideForm, Label, Dropdown, Bg) {
        this.container = SlideForm
        this.label = Label
        this.dropdown = Dropdown
        this.arrow = Bg
    },

    toggleOpen () {
        const tl = new TimelineLite()
        tl.set(this.dropdown, { visibility: 'visible', height: 'auto' })
        tl.set(this.label, { borderBottom: 'none', height: '43px', borderRadius: '5px 5px 0 0' })
        tl.from(this.dropdown, 1.2, { height: '0', ease: Elastic.easeOut.config(1, 0.4) })
        tl.to(this.arrow, 0.2, { transform: 'rotate(0deg)' }, 0)
    },

    toggleClose () {
        if (this.dropdown && this.dropdown.offsetHeight > 1) {
            const tl = new TimelineLite()
            const borderColor = (this.container.classList.contains('white') ? '#FFFFFF' : '#004346')

            tl.to(this.dropdown, 0.3, { height: '0', ease: Power4.easeOut })
            tl.to(this.arrow, 0.1, { transform: 'rotate(-90deg)' }, 0)
            tl.set(this.label, { border: '1px solid ' + borderColor, height: '42px', borderRadius: '5px' }, 0.1)
            tl.set(this.dropdown, { visibility: 'hidden' }, 0.1)
        }
    }

}



// WEBPACK FOOTER //
// ./resources/js/elements/FancySelect/animations.js